var exports = {
  "wrapper": "xaee3c4fa--7d90aa--wrapper",
  "image": "xaee3c4fa--7d90aa--image",
  "image-link": "xaee3c4fa--7d90aa--image-link",
  "cian-logo": "xaee3c4fa--7d90aa--cian-logo",
  "content": "xaee3c4fa--7d90aa--content",
  "_ellipsis": "xaee3c4fa--7d90aa--_ellipsis",
  "name-wrapper": "xaee3c4fa--7d90aa--name-wrapper",
  "name": "xaee3c4fa--7d90aa--name",
  "description": "xaee3c4fa--7d90aa--description",
  "_fs14": "xaee3c4fa--7d90aa--_fs14",
  "_fs16": "xaee3c4fa--7d90aa--_fs16",
  "_strong": "xaee3c4fa--7d90aa--_strong",
  "icon-trusted": "xaee3c4fa--7d90aa--icon-trusted",
};

module.exports = exports;
